import React from "react";
import SlideOver from "../../components/ui/SlideOver";
import AllocateAsset from "../../component/AssetManagement/AllocateAsset";

/**
 * Wraps the existing AllocateAsset component in a slide-over so the
 * bulk allocation workflow stays available without taking the user to
 * a separate full-page tab. preselectedAssetIds is currently advisory
 * — AllocateAsset manages its own selection state internally; deeper
 * preselection support can be added by extending AllocateAsset to read
 * an `initialAssetIds` prop, then forwarding it here.
 */
// eslint-disable-next-line no-unused-vars
export default function BulkAllocateSlideOver({open, onClose, preselectedAssetIds, onAllocated}) {
  return (
    <SlideOver
      open={open}
      onOpenChange={(o) => !o && onClose && onClose()}
      title="Allocate assets"
      subtitle="Assign one or more assets to a user."
      size="xl"
    >
      <SlideOver.Body className="p-0">
        <div className="px-2 sm:px-4 py-4 legacy-in-slideover">
          {/* The original AllocateAsset renders its own toolbar, employee
              picker, asset list and Allocate button. Letting it own its
              UI keeps API contracts and validation logic untouched. */}
          <AllocateAsset />
        </div>
      </SlideOver.Body>
    </SlideOver>
  );
}
